import { cn } from '@/shared/utils/formatting';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-white/[0.10]', className)} {...props} />;
}

export { Skeleton };
